export default {
  presenter: 'kaplan',
  title: 'Icinga za 50 minut',
  subtitle: 'začátečníci',
  text: `
Icinga je systém pro dohled systémů - hlídá servery a služby na nich 24x7. Může mi poslat zprávu, že
se něco rozbilo nebo to dokonce kusit opravit.  
V průběhu přednášky se podíváme, z čeho se Icinga2 skládá, jak pracuje. Zkusíme si zkusit,
jak Icingu nainstalovat a jak jí vysvětlit, co má hlídat.
  `,
}



// WEBPACK FOOTER //
// ./src/content/installfest/data/presentations/kaplan-icinga.js